/* ============================================
   HAEZEL TECH — Mobile Filter Accordion Fix v7
   Overrides MenuDrawer prototype before
   customElements.define is called
============================================ */

(function() {
  'use strict';

  // Intercept customElements.define to patch MenuDrawer before it registers
  var originalDefine = customElements.define.bind(customElements);
  
  customElements.define = function(name, constructor, options) {
    if (name === 'menu-drawer') {
      // Patch the onSummaryClick method on the prototype
      var originalOnSummaryClick = constructor.prototype.onSummaryClick;
      
      constructor.prototype.onSummaryClick = function(event) {
        var summary = event.currentTarget;
        var details = summary.parentNode;
        
        // If this is a filter group summary — accordion behaviour
        if (summary.classList.contains('mobile-facets__summary')) {
          event.preventDefault();
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          }
          return;
        }
        
        // Everything else — Dawn's normal behaviour
        originalOnSummaryClick.call(this, event);
      };
    }
    
    // Call original define
    originalDefine(name, constructor, options);
  };

})();
